import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createCombineName } from 'mt-react-common/modules/comments/reducers/form/naming';
import { createCombineReducers } from 'mt-react-common/modules/comments/reducers/form/combine';
import CommentForm from '../../CommentForm';

class CommentFormRWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: createCombineName(
        `${this.props.modelClass}-${this.props.modelId}`
      )
    };
  }

  componentWillMount() {
    createCombineReducers(this.state.reducerName);
  }

  render() {
    return (
      <React.Fragment>
        <CommentForm {...this.props} reducerName={this.state.reducerName} />
      </React.Fragment>
    );
  }
}

CommentFormRWrapper.defaultProps = {};

CommentFormRWrapper.propTypes = {
  modelClass: PropTypes.string.isRequired,
  modelId: PropTypes.number.isRequired,
  commentsOwnerId: PropTypes.number.isRequired,

  listReducerName: PropTypes.string.isRequired,
  commentsInStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired
};

export default CommentFormRWrapper;



// WEBPACK FOOTER //
// ./src/components/Comment/ReducerWrappers/CommentFormRWrapper/CommentFormRWrapper.js